import { addClassStyleAttrs as e, removeClassStyleAttrs as t } from "../../common/utils/index.js";
import { t as n } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import { MUTED as r } from "../link/link-constants.js";
import i from "../link/link.js";
import { BREADCRUMB_ITEM_SELECTED_MODIFIER as a } from "./breadcrumbs-constants.js";
import { createElementBlock as o, createTextVNode as s, createVNode as c, mergeProps as l, openBlock as u, renderSlot as d, resolveComponent as f, toDisplayString as p, withCtx as m } from "vue";
//#region components/breadcrumbs/breadcrumb_item.vue
var h = {
	name: "DtBreadcrumbItem",
	components: { DtLink: i },
	inheritAttrs: !1,
	props: {
		inverted: {
			type: Boolean,
			default: !1
		},
		selected: {
			type: Boolean,
			default: !1
		},
		label: {
			type: String,
			default: ""
		},
		rootClass: {
			type: [
				String,
				Object,
				Array
			],
			default: ""
		}
	},
	data() {
		return { BREADCRUMB_ITEM_SELECTED_MODIFIER: a };
	},
	computed: {
		linkKind() {
			return this.inverted ? "" : r;
		},
		linkInverted() {
			return !!this.inverted;
		},
		ariaCurrent() {
			return this.selected ? "location" : void 0;
		}
	},
	methods: {
		removeClassStyleAttrs: t,
		addClassStyleAttrs: e
	}
};
function g(e, t, n, r, i, a) {
	let h = f("dt-link");
	return u(), o("li", l({
		"data-qa": "dt-breadcrumb-item",
		class: [
			n.rootClass,
			"d-breadcrumbs__item",
			{ [i.BREADCRUMB_ITEM_SELECTED_MODIFIER]: n.selected }
		]
	}, a.addClassStyleAttrs(e.$attrs)), [c(h, l({
		kind: a.linkKind,
		inverted: a.linkInverted,
		"aria-current": a.ariaCurrent,
		"data-qa": "breadcrumb-item"
	}, a.removeClassStyleAttrs(e.$attrs)), {
		default: m(() => [d(e.$slots, "default", {}, () => [s(p(n.label), 1)])]),
		_: 3
	}, 16, [
		"kind",
		"inverted",
		"aria-current"
	])], 16);
}
var _ = /* @__PURE__ */ n(h, [["render", g]]);
//#endregion
export { _ as default };

//# sourceMappingURL=breadcrumb-item.js.map